var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter_list_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/content/filter_list_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.09033V8.08029H21V6.09033H3ZM10 18.0301H14V16.0401H10V18.0301ZM18 13.0552H6V11.0652H18V13.0552Z",
    fill: "#8993A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterList);
export default __webpack_public_path__ + "static/media/filter-list.976c35fcc4a827685bae3c72a2982ddf.svg";
export { ForwardRef as ReactComponent };